export default [
  {
    path: '/catalogostatok',
    name: 'catalogostatok-index',
    component: () => import('../views/catalogostatok/index.vue')
  }
]

